// React
import React, { cloneElement } from 'react'
import PropTypes from 'prop-types'

// Components
import BPopover from 'ui/blocks/Popover'

// Utils
import { shouldForwardProp } from 'shared/utils/shouldForwardProp'

// Helper function to filter props for DOM elements
const filterPropsForElement = (element, props) => {
  // Return an empty object if element is null or undefined
  if (!element) {
    return {}
  }
  // Ensure the element is a valid React element
  if (!React.isValidElement(element)) {
    return { ...props }
  }

  // If it's not a DOM element (intrinsic element), pass all props
  if (typeof element.type !== 'string') {
    return { ...props }
  }

  // For DOM elements, filter out props that aren't valid HTML attributes
  const filteredProps = {}
  Object.keys(props).forEach((key) => {
    if (shouldForwardProp(key, element.type)) {
      filteredProps[key] = props[key]
    }
  })
  return filteredProps
}

const Content = ({
  opened,
  useContentWrapper,
  content,
  contentProps,
  target,
  isMobile,
  useArrow,
  noOverflow,
  color,
  defaultPopoverStyling,
  direction
}) => {
  if (!opened || !content) return null

  if (useContentWrapper) {
    return (
      <BPopover.Content data-tid={target} interactive tippy notFixed>
        <BPopover.Inner color={color} noOverflow={noOverflow} interactive defaultPopoverStyling={defaultPopoverStyling}>
          {typeof content === 'function' ? content(contentProps) : cloneElement(content, filterPropsForElement(content, contentProps))}
          {!isMobile && useArrow && !noOverflow && (
            <BPopover.TippyArrow color={color} direction={direction} className="tippy-arrow" data-popper-arrow="" />
          )}
        </BPopover.Inner>
        {!isMobile && useArrow && noOverflow && (
          <BPopover.TippyArrow color={color} direction={direction} className="tippy-arrow" data-popper-arrow="" />
        )}
      </BPopover.Content>
    )
  }

  return typeof content === 'function' ? content(contentProps) : cloneElement(content, filterPropsForElement(content, contentProps))
}

Content.propTypes = {
  opened: PropTypes.bool,
  content: PropTypes.oneOfType([PropTypes.func, PropTypes.node, PropTypes.string]),
  contentProps: PropTypes.object,
  useArrow: PropTypes.bool,
  useContentWrapper: PropTypes.bool,
  isMobile: PropTypes.bool,
  target: PropTypes.string,
  defaultPopoverStyling: PropTypes.bool,
  noOverflow: PropTypes.bool,
  color: PropTypes.string,
  direction: PropTypes.string
}

export default Content
